module.exports = __webpack_public_path__ + "eeeeed179e89ae78f642e007b4a2ee56.svg";